<template>
  <tr>
    <td :style="{ backgroundColor: adColor }"></td>
    <td class="pl-4 py-2">
      <div :style="{ color: adColor }">
        <slot name="status" :style="{ color: adColor }"></slot>
      </div>
    </td>
    <td>
      <div class="switch">
        <label>
          <input
            id="profile-switch-input"
            type="checkbox"
            checked
            v-model="activate"
          />
          <span id="profile-switch-lever" class="lever"></span>
          <!-- {{activate}} -->
        </label>
      </div>
    </td>
    <td>
      <slot name="title"></slot>
    </td>
    <td>
      $
      <slot name="price"></slot>
    </td>
  </tr>
</template>
<script>
export default {
  props: ["activate", "adColor"],
  data() {
    return {
      status: "deleted",
      toActivate: false,
      title: "Some title",
      price: 50
    };
  }
};
</script>

<style scoped>
.switch
  label
  input#profile-switch-input[type="checkbox"]:checked
  + #profile-switch-lever.lever::after {
  background-color: rgb(131, 68, 233);
}
.switch label input[type="checkbox"]:checked + .lever {
  background-color: rgb(208, 179, 255);
}
td {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Ad.vue